import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'csi-filter-dashboard',
  templateUrl: './filter-dashboard.component.html',
  styleUrls: ['./filter-dashboard.component.scss']
})
export class FilterDashboardComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
